
import { BlogPost } from "@/types/blog";
import { content } from "./content";

export const GesundesVerhaeltnisZuGeld: BlogPost = {
  title: "Ein gesundes Verhältnis zu Geld entwickeln – Wie du finanzielle Klarheit gewinnst",
  metaTitle: "Gesundes Verhältnis zu Geld: Klarheit gewinnen",
  excerpt: "Praktische Tipps und Übungen für ein bewussteres Verhältnis zu Geld und Finanzentscheidungen im Einklang mit Ihren Werten.",
  date: "30.01.2025",
  
  slug: "gesundes-verhaeltnis-zu-geld",
  imageUrl: "/images/blog/finanzen-analyse.jpg",
  category: "Finanzpsychologie",
  tags: ["Finanzpsychologie", "Geldblockaden", "Finanzcoaching", "Klarheit", "Werte"],
  author: "Jörg Hörmann",
  authorTitle: "Finanz- & Executive Coach",
  content
};
